"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSource = exports.isProduction = exports.loadConfiguration = void 0;
/**
 * loads the configuration file and parses it
 * @param path url of the path where configuration file is located
 */
function loadConfiguration(path) {
    return fetch(path).then(i => (i.json()));
}
exports.loadConfiguration = loadConfiguration;
function isProduction(environment) {
    return environment === 'production';
}
exports.isProduction = isProduction;
exports.ConfigSource = {
    from: (config) => ({
        load: () => Promise.resolve(config)
    }),
    fromFile: (path) => ({
        load: () => loadConfiguration(path)
    })
};
//# sourceMappingURL=utils.js.map